<template>
  <div>
    <div class="banner">
      <div class="titleSub">Contact Us</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">联系我们</div>
      <div class="desc wow animate__animated durationTime animate__fadeInUp">专业的市场、方案、运维服务团队,<br>
        随时为您提供全面的售前、售后服务支持。</div>
    </div>
    <div class="coll">
      <div>
        <div class="titleSub">Collaborative consulting</div>
        <div class="title wow animate__animated durationTime animate__fadeInUp">合作咨询</div>
        <div class="contact wow animate__animated durationTime animate__fadeInUp">
          <img class="pic" src="../../assets/image/about/tel.png">
          <div  class="desc">服务热线：</div>
          <div class="tel">18665393445</div>
        </div>
        <div class="contact wow animate__animated durationTime animate__fadeInUp">
          <img style="width: 0.1662rem;height: 0.1246rem" class="pic" src="../../assets/image/about/email.png">
          <div  class="desc">电子邮箱：</div>
          <div class="tel">info@magicwifi.com.cn</div>
        </div>
        <div class="contact wow animate__animated durationTime animate__fadeInUp">
          <img style="width: 0.1455rem;height: 0.1819rem"  class="pic" src="../../assets/image/about/address.png">
          <div class="desc">联系地址：</div>
          <div class="tel">深圳市南山区科技园南长虹科技大厦2105</div>
        </div>
      </div>
      <div class="wx-public wow animate__animated durationTime animate__fadeInUp">
<!--        <div id="wl-qrcode1"></div>-->
        <img v-if="imgFlag==0" class="wx-public-img" src="@/assets/image/index/wx-public.jpg">
        <img v-else class="wx-public-img" :src="img">
        <div class="wx-public-text">扫码联系我们</div>
      </div>
    </div>
    <baiduMap />
  </div>
</template>

<script>
import baiduMap from './components/baiduMap';

export default {
  name: "talent",
  data(){
    return{
      imgFlag:0,
      img:'',
    }
  },
  components:{
    baiduMap
  },
  mounted() {

  },
  created() {
    this.initializeAndRun();
  },
  methods:{
    loadScript(src, id) {
      return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
          resolve(); // 如果脚本已经存在，直接resolve
          return;
        }

        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.id = id;

        script.onload = () => {
          resolve(); // 脚本加载成功，resolve
        };

        script.onerror = () => {
          reject(new Error(`Script load error for ${src}`)); // 脚本加载失败，reject
        };

        let s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
      });
    },
    async initializeAndRun() {
      try {
        await this.loadScript(
          'https://material.weiling.cn/h5/willing-third-party-js/v1/qrcode-custom-comp-v1.min.js',
          'wlQRCS'
        );

        // 等待脚本加载完成后初始化
        wlQrcodeCustomComp.init({
          wl_id: 'wpW2WmDAAAsuSkpyHYrwjV4tnMu-Zjag', // [修改1：将wl_id粘贴至此]
        });

        // 初始化完成后要执行的代码
        console.log('wlQrcodeCustomComp initialized');
        // 在这里添加你需要执行的代码
        this.getCode();
      } catch (error) {
        console.error(error); // 处理加载脚本时的错误
      }
    },
    getCode(){
      wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: "1801157726622015488", //  [修改1：将wl_qrcode_id粘贴至此]
        },
        (data) => {
          console.log(data); // data中包含二维码图片地址
          if(data.code==200){
            this.imgFlag=1;
            this.img=data.data.qr_code;
          }
        }
      );
    }
  }
}
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  background: url('../../assets/image/about/contact-bg.png') center no-repeat;
  background-size: cover;
  padding-left: 2.18rem;
.title {
  font-size: 0.44rem;
  font-weight: 500;
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  margin-top: 2.35rem;
  position: relative;
  color: #fff;
  display: inline-block;
}
.titleSub {
  content: "NEWS";
  position: absolute;
  margin-top: 2.04rem;
  font-size: 0.44rem;
  font-weight: 500;
  color: rgb(169 160 160 / 51%);
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  letter-spacing: 0.02rem;
}
.desc{
  font-weight: 400;
  font-size: 0.24rem;
  color: #FFFFFF;
  margin-top: 0.2rem;
  line-height: 0.4rem;
  letter-spacing: 0.05rem;
}
}
.coll {
  width: 100%;
  background: url('../../assets/image/about/coll-bg.png') center no-repeat;
  background-size: cover;
  padding:1rem 2.18rem 1.4rem 2.18rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
.title {
  font-size: 0.34rem;
  font-weight: 500;
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  margin-top: 0.24rem;
  position: relative;
  color: #333333;
  display: inline-block;
  margin-bottom: 0.55rem;
}
.titleSub {
  position: absolute;
  font-size: 0.34rem;
  font-weight: 500;
//color: rgba(255, 255, 255, 0.51);
  color: #c8c8c8;
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  letter-spacing: 0.02rem;
}
.contact{
  display: flex;
  margin-bottom: 0.43rem;
  align-items: center;
.pic{
  width: 0.17rem;
  height: 0.17rem;
  margin-right: 0.1rem;
}
.desc{
  width: 0.8rem;
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
}
.tel{
  color: #333333;
  font-weight: bold;
  font-size: 20px;
  font-family: DIN Alternate, DIN Alternate;
}
}
.wx-public{
  display: flex;
  flex-direction: column;
  align-items: center;
.wx-public-img{
  width: 1.66rem;
  height: 1.66rem;
}
.wx-public-text{
  margin-top: 0.2rem;
  font-weight: 400;
  font-size: 0.16rem;
  color: #333333;
}
}

}
</style>



// WEBPACK FOOTER //
// src/pages/about/talent.vue